import { render, staticRenderFns } from "./income-payment-received.vue?vue&type=template&id=537f3ba7"
import script from "./income-payment-received.js?vue&type=script&lang=js&external"
export * from "./income-payment-received.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports